import {
  arrayUnion,
  doc,
  getDoc,
  updateDoc,
  collection,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AddRedirect from "./AddRedirect";
import { auth, db } from "./firebaseconfig";
import Login from "./Login";
import RedirectPage from "./RedirectPage";

function Redirect() {
  const [status, setStatus] = useState("redirect");
  let { id } = useParams();
  const docRef = doc(collection(db, "urls"), `${id.toLowerCase()}`);
  const trackingRef = doc(collection(db, "tracking"), `${id.toLowerCase()}`);
  const utm =
    new URLSearchParams(window.location.search).get("utm")?.toLowerCase() || "";

  useEffect(() => {
    const getFbDocument = async () => {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(trackingRef, {
          visits: arrayUnion({
            timestamp: new Date().toISOString(),
            utm,
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
          }),
        });
        window.location.replace(docSnap.data().url);
      } else if (auth.currentUser) {
        setStatus("add");
      } else {
        setStatus("login");
      }
    };

    getFbDocument();
  }, []);

  return status === "redirect" ? (
    <RedirectPage />
  ) : status === "add" ? (
    <AddRedirect id={id} />
  ) : (
    <Login />
  );
}

export default Redirect;
